import { Link } from "react-router-dom";


export type NavElementProps = {
    to: string;
    image: string;
    indent?: number;
    children?: React.ReactNode;
};


export const NavElement: React.FC<NavElementProps> = ({ to, children, image, indent = 0 }) => (
    <nav className="he-is-coming-nav-link" >
        <img className="nav-arrow" src="/resources/menu/menu_arrow.png" alt="" />
        <span style={{ display: 'inline-block', width: `${indent * 64}px` }} />
        <Link to={to}><img className="nav-icon" src={image} alt="Nav Icon" />{children}</Link>
    </nav>
);
